import { moveOutline } from 'ionicons/icons';
import { ReactElement, useMemo } from 'react';
import { useFlipCardContext } from '../../../../../../components/ui/flip-card-context';
import { getLocalizedText } from '../../../../../../i18n/i18n.utils';
import { useFlowServices } from '../../../hook/flow-service.hooks';
import { FlowItem } from '../../../model/flow.types';
import { FlowItemShift } from '../shift/flow-item-shift';
import { FlowItemBaseAction } from './flow-item-base-action';

interface FlowItemShiftActionProps {
  items: FlowItem[];
  disabled?: boolean;
  onClick?: () => Promise<void>;
}

const FlowItemShiftAction = (props: FlowItemShiftActionProps): ReactElement => {
  const { disabled, items, onClick } = props;
  const { flowAnalyticService, flowItemService } = useFlowServices();
  const { setBack, showBack } = useFlipCardContext();

  const hasShiftableItem = useMemo(() => {
    return flowItemService.hasShiftableItem(items);
  }, [items, flowItemService]);

  return (
    <FlowItemBaseAction
      icon={moveOutline}
      label={getLocalizedText('common:shift')}
      disabled={disabled || !hasShiftableItem}
      onClick={async () => {
        flowAnalyticService.trackShiftInitiated();
        if (onClick) {
          await onClick();
        } else {
          setBack(<FlowItemShift dismiss={() => showBack(false)} />, true);
        }
      }}
    />
  );
};

export { FlowItemShiftAction };
